import React from "react";

import LineGraph from "../HourLineGraph";

import styles from "./MetricBox.module.scss";

interface MetricBoxProps {
  title: string;
  value: string;
  subtitle: string;
  graphData: number[];
  startDate: Date;
  minY?: number;
  getTooltipLabel?: (index: number) => string;
}

const MetricBox = ({
  title,
  value,
  subtitle,
  graphData,
  startDate,
  minY = 0,
  getTooltipLabel,
}: MetricBoxProps) => {
  return (
    <div className={styles.metricBox}>
      <div className={styles.title}>{title}</div>
      <div className={styles.values}>
        <span className={styles.number}>{value}</span>
        <span className={styles.subtitle}>{subtitle}</span>
      </div>
      <div className={styles.chart}>
        <LineGraph
          values={graphData}
          startDate={startDate}
          minY={minY}
          getTooltipLabel={getTooltipLabel}
        />
      </div>
    </div>
  );
};

export default MetricBox;
